const state = () => ({
  hot: null,
  sector: null,
  specialism: null,
  trendingsIn: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, url);
      });
  },

  async getShortData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.baseURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, url);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
